import React from 'react';
import { navigateTo } from './helpers/Helpers.js';
import home from './home.svg';
import './Header.css';

/* TODOs:
- Add Logo
*/
class Header extends React.Component {
  render() {
    const { selected, backgroundColor, textColor } = this.props;
    
    const style = {};
    if (backgroundColor) {
      style.backgroundColor = backgroundColor;
      style.color = textColor || "var(--white)";
    }
    
    return (
      <div className="Header-Wrapper" style={style}>
        <div
          className={"Header-Item"}
          style={selected === "About" ? {"fontWeight": "bold"} : {}}
          onClick={() => navigateTo("/about")}>
          About
        </div>
        <img
          className="Header-Item"
          style={{ width: 30 }}
          src={home}
          alt="Home Button"
          onClick={() => navigateTo("/")}
        />
        <div
          className="Header-Item"
          style={selected === "Projects" ? {"fontWeight": "bold"} : {}}
          onClick={() => navigateTo("/projects")}>
          Projects
        </div>
      </div>
    );
  }
}

/*
<div
  className="Header-Item"
  style={this.selected === "Experience" ? {"fontWeight": "bold"} : {}}
  onClick={() => goTo("/experience", false)}>
  Experience
</div>
*/

export default Header;
